export interface DownloadModuleOptionsModel {
  empty?: boolean;
  data?: any;
  positionId?: string;
}
